import { useState } from 'react';

export default function useToken() {

    // retourne le token récupéré depuis le sessionstorage
    const getToken = () => {
        const tokenString = sessionStorage.getItem('token');
        if (!tokenString) return null;
        
        // Handle both JSON-stringified and plain string tokens
        try {
            return JSON.parse(tokenString);
        } catch {
            return tokenString;
        }
    };

    const [token, setToken] = useState(getToken);

    const getCode = () => {
        const codeString = sessionStorage.getItem('code');
        return codeString || null;  // ✅ FIX: No JSON.parse needed
    };

    // sauvegarder le token (depuis le login)
    const saveToken = userToken => {
        sessionStorage.setItem('token', JSON.stringify(userToken.token));
        sessionStorage.setItem('auth', JSON.stringify(userToken.auth));
        sessionStorage.setItem('code', userToken.code);  // ✅ Store as string
        sessionStorage.setItem('language', userToken.language);
        
        // Store admin authorities if present
        if (userToken.adminAuthorities) {
            sessionStorage.setItem('adminAuthorities', JSON.stringify(userToken.adminAuthorities));
        }
        
        setToken(userToken.token);
        
        // Enable PWA for superadmin users
        if (window.enablePWAForSuperAdmin) {
            window.enablePWAForSuperAdmin();
        }
    };

    return {
        token,
        setToken: saveToken,
        code: getCode()
    }
}